<template>
  <LibraryCard
    :url="presentLevelsUrl"
    :updated-time="presentLevel.content_body.updated_at"
    :internal-link="true"
    :new-window="shared">
    <div class="presentlevel-card-body remove-resource-btn-container">
      <RemoveResourceButton
        v-if="!shared"
        :resource-id="presentLevel.content_uuid"
        :collection-id="presentLevel.collection_uuid"
        :type="resourceType" />
      <h4 class="fs-block"> {{ plHeading }} </h4>
      <p class="text-muted-dark"> {{ plAreasStatement }} </p>
    </div>
  </LibraryCard>
</template>

<script>
import { CONTENT_TYPES } from '@/util/access_visibility'
import LibraryCard from '@/components/library/LibraryCard'
import RemoveResourceButton from '@/components/library/RemoveResourceButton'
import { noSelMixin } from '@/contentprofile/no_sel_mixins'

export default {
  name: 'LibraryPresentLevelsCard',
  components: {
    LibraryCard,
    RemoveResourceButton
  },
  mixins: [noSelMixin],
  props: {
    presentLevel: {
      type: Object,
      required: true
    },
    shared: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceType: CONTENT_TYPES.PRESENTLEVEL
    }
  },
  computed: {
    presentLevelsUrl() {
      return this.shared
        ? { name: 'SharedPresentLevelsPage', params: { uuid: this.presentLevel.content_uuid } }
        : { name: 'PresentlevelsConclusion', params: { uuid: this.presentLevel.content_uuid } }
    },
    plHeading() {
      return (
        this.presentLevel.content_body.student_name +
        ' (' +
        this.presentLevel.content_body.enrolled_grade_level +
        ' grade)'
      )
    },
    plAreasStatement() {
      return 'Present level areas: '.concat(this.getPlAreaLabelsFromValues(this.presentLevel.content_body.selected_subjects).join(', '))
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
@import '~@/components/library/library_styles.less';
.presentlevel-card-body {
  padding: 20px;
  line-height: 20px;
  padding-bottom: 0px;
  margin-bottom: 12px;

  h4 {
    font-weight: bold;
    color: @link-color;
    margin-top: 0;
    margin-bottom: 14px;
  }

  &:hover, &:focus {
    h4 {
      color: @link-hover-color;
    }
  }
  .text-muted-dark {
    margin-top: 12px;
  }
}
</style>
